import { supabase } from '../client'

export async function deleteAuction(id: number) {
  const { data, error } = await supabase.from('auctions').delete().match({ id })
  return { data, error }
}
